import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class EmailConfirmation extends ApplicationRecord {
  static jsonapiType = 'confirmation-email-requests';

  @Attr() email: string;
}
